<!--  -->
<template>
  <div>
    <el-input v-model="keyword" style="width:200px;margin-bottom:10px" placeholder="请输入内容" />
    <el-button type="primary" style="margin-left:10px" icon="el-icon-search" @click="sraw">搜索</el-button>
    <el-button type="primary" @click="awered">重置</el-button>
    <div class="book_table">
      <el-table
        ref="table"
        :key="refreshKey"
        v-loading="loading"
        :data="publicAdvertListr"
        border
        style="width: 100%"
      >
        <el-table-column
          align="center"
          prop="platformStr"
          label="书籍图片"
          width="130"
        >
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.img"
              fit="contain"
            />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="book_id"
          label="书籍id"
        />
        <el-table-column
          align="center"
          prop="platformStr"
          label="平台"
          width="100"
        />
        <el-table-column
          align="center"
          prop="book_title"
          label="书籍名称"
        />
        <el-table-column
          align="center"
          prop="view_title"
          label="书籍别名"
        />
        <el-table-column
          align="center"
          label="操作"
          width="100"
        >
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="chooserr(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination-right
      ref="paginationbox"
      :total="newtotalr"
      @size-change="fetchPageSizer($event)"
      @current-change="fetchCurrentPager"
    />

    <el-dialog
      title="选择章节"
      :visible.sync="zhangjiedialogVisible"
      :append-to-body="true"
      width="30%"
    >
      <el-table
        ref="table"
        :data="zhangjiearr"
        border
        style="width: 100%"
        :max-height="600"
      >
        <el-table-column
          align="center"
          prop="chapter_id"
          label="章节id"
          width="180"
        />
        <el-table-column
          align="center"
          prop="chapter_name"
          label="章节名称"
          width="300"
        />

        <el-table-column
          align="center"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="choosechater(scope.row,scope.$index)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { novellist, createtemplate } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      input: '',
      page: 1,
      pageSize: 10,
      keyword: null,
      refreshKey: 0,
      loading: false,
      publicAdvertListr: [],
      newtotalr: null,
      kefuid: '',
      query: null,
      zhangjiedialogVisible: false,
      zhangjiearr: [],
      querybookid: '',
      chuanbiao: ''
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    // 获取客服消息
    menuList() {
      this.loading = true
      novellist({
        page: this.page,
        page_size: this.pageSize,
        novel_title: this.keyword,
        platform_id: this.query
      }).then(res => {
        console.log('res.data.list', res.data.list)
        this.publicAdvertListr = res.data.data.list
        this.loading = false
        // this.publicAdvertListr.forEach(item => {
        //   // item.checkboxFlag = false
        //   this.$set(item, 'checkboxFlag', false)
        //   if (item.customerMessageNo === this.kefuid) {
        //     item.checkboxFlag = true
        //   }
        // })
        this.newtotalr = res.data.data.total
      })
    },
    sraw() {
      this.page = 1
      this.pageSize = 10
      this.menuList()
    },
    awered() {
      this.page = 1
      this.pageSize = 10
      this.keyword = null
      this.menuList()
    },
    send(val) {
      console.log('val6666666666', val)
      this.query = val
      // if (val === '') {
      //   console.log('kong')
      // } else {
      //   this.kefuid = val
      //   console.log('bukong')
      // }
      this.menuList()
    },
    // 分页
    fetchPageSizer(e) {
      this.pageSize = e
      this.menuList()
    },
    fetchCurrentPager(e) {
      this.page = e
      this.menuList()
    },
    handleChangeSelectone(index) {
      console.log(this.publicAdvertListr[index])
      if (!this.publicAdvertListr[index].checkboxFlag) {
        console.log('item', this.publicAdvertListr[index])
        this.$emit('callback', this.publicAdvertListr[index].customerMessageNo)
      } else {
        // this.selectData = null
      }
      this.publicAdvertListr.forEach(item => {
        item.checkboxFlag = false
      })
      this.publicAdvertListr[index].checkboxFlag = true
    },
    chooserr(item) {
      // this.$emit('callback', item)
      console.log('item', item)
      this.querybookid = item.id
      this.book_id = item.book_id
      this.zhangjiedialogVisible = true
      this.relist()
    },
    relist() {
      createtemplate({
        novel_id: this.querybookid,
        platform_id: this.query
      }).then(res => {
        console.log('res', res)
        this.zhangjiearr = []
        this.zhangjiearr = res.data.chapter
      })
    },
    choosechater(item) {
      console.log('item', item)
      this.chuanbiao = ''
      // this.chuanbiao = `platform_book_link_${this.book_id}_${item.chapter_id}`
      this.chuanbiao = `\${platform_book_link_${this.book_id}_${item.chapter_id}}`
      // const key = `platform_book_link_${this.book_id}_${item.chapter_id}`
      // this.chuanbiao = `\${${key}}`
      this.zhangjiedialogVisible = false
      this.$emit('callchoooseter', this.chuanbiao)
    }

  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.book_table{
  max-height: 580px;
  overflow: hidden;
  overflow-y: scroll;
}
</style>
